/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import dayjs from '../../utils/config/dayjs';
import { TableTotal, ColumnContainerSummary, ArrowHolderSummary } from './styles';
import { Utils } from '../../utils/api';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';

export default ({ dataTableContent }: { dataTableContent: Array<any> }) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent || []);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function handleAmount(data) {
    return (data !== null ||data !== undefined) ? `$ ${data}` : '-';
  }
  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  function SortingTableHead({ title = '', attr, location, sortFunction }) {
    return (
      <th onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </th>
    );
  }

  function firstToUpperCase(text: String) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return (
    <TableTotal minWidth="500px">
      <thead>
        <tr>
          <SortingTableHead title="Purchase Date" attr="month" location={['date']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Yearly Sponsorships" attr="memberships" location={['numberOfPlayers']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Payment" attr="payment" location={['amount']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Status" attr="status" location={['status']} sortFunction={toggleSortString} />
        </tr>
      </thead>
      <tbody>
        {table?.length > 0 ? (
          <>
            {table?.map((el, idx) => (
              <tr key={idx}>
                <td>{dayjs(el?.date).format('MM/DD/YYYY')}</td>
                <td>{el?.numberOfPlayers}</td>
                <td>{handleAmount(el?.amount?.toFixed(2))}</td>
                <td>{firstToUpperCase(el?.status)}</td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={6}>No data</td>
          </tr>
        )}
      </tbody>
    </TableTotal>
  );
};
